import { useContext } from 'react';
import { OptimizelyContext } from 'lib/optimizely/optimizely';
import { OptimizelyContextValue } from 'lib/optimizely/optimizely.types';

const FEATURE_FLAG_NAME = 'qantas-hotels-expt_6-remove_points_plus_pay';
const VARIATION_KEY = 'remove_points_plus_pay';

interface Result {
  removePointsPlusPay: boolean;
}

const useRemovePointsPlusPay = (): Result => {
  const optimizelyContext = useContext(OptimizelyContext) as OptimizelyContextValue;
  const decision = optimizelyContext?.decisions?.[FEATURE_FLAG_NAME];

  const isReady = optimizelyContext?.isReady ?? false;
  const { enabled = false, variationKey } = decision || {};

  return {
    removePointsPlusPay: isReady && enabled && variationKey === VARIATION_KEY,
  };
};

export default useRemovePointsPlusPay;
